<template>
  <div class="window">
    <div class="colse">
      <p @click="$parent.paymentFlowShow=false">+</p>
    </div>
    <div id="manage" :style="{'height':manageHeight+'px'}">
      <div class="condition">
        <div class="firstInput">
          <p>支付时间</p>
          <el-date-picker
            size="small"
            v-model="startAndEndTime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <div class="searchBtn">
          <el-button size="small" type="primary" @click="refresh()">查询</el-button>
          <el-button size="small" type="primary" @click="exportFun()">导出</el-button>
        </div>
      </div>
      <el-table size="small" :data="tableData" stripe :max-height="tableMaxHeight" class="table">
        <el-table-column fixed label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          v-for="(column, index) in columns"
          :fixed="column.fixed"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :key="index"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "paymentFlow",
  data() {
    var that = this;
    return {
      startAndEndTime: "",
      manageHeight: 0,
      ref: "form",
      isDisabled: false, //表单是否可以编辑
      tableMaxHeight: 0, //表格的最大高度
      //搜索条件
      searchParam: {
        startTime: "",
        endTime: ""
      },
      // 新增，编辑 表单校验
      sendType: "", //add 表示新增  edit 表示编辑 view 表示预览
      tableData: [],
      //表格列配置
      columns: [
        { fixed: false, prop: "payNo", label: "流水号", width: "-" },
        { fixed: false, prop: "ctUnitId", label: "收运单位", width: "-" },
        { fixed: false, prop: "orderId", label: "订单", width: "-" },
        { fixed: false, prop: "payType", label: "支付方式", width: "-" },
        { fixed: false, prop: "payAccount", label: "支付账户", width: "-" },
        { fixed: false, prop: "payAmount", label: "支付金额", width: "-" },
        { fixed: false, prop: "payTime", label: "支付时间", width: "-" }
      ]
    };
  },
  mounted() {
    var that = this;
    window["setParam"] = (id, unitId) => {
      that.setParam(id, unitId);
    };
    this.$nextTick(function() {
      //设置表格的最大高度
      setTimeout(function() {
        var height = document.body.clientHeight;
        var conditionHeight = document.getElementsByClassName("condition")[0]
          .clientHeight; //条件框高度
        var marginBottom = 12; //筛选条件和表格的距离
        var pageHeight = 0; //分页的高度
        var closeHeight = 38; //关闭功能高度
        that.tableMaxHeight =
          height - conditionHeight - marginBottom - pageHeight - closeHeight;
        that.manageHeight = height - closeHeight;
      }, 500);
    });
  },
  methods: {
    exportFun() {
      //导出
      var searchParam = {};
      var param = JSON.stringify(this.beforeRefresh(searchParam));
      window.location.href =
        api.url_synergism_payments_export + "?param=" + encodeURI(param);
    },
    handleClose(done) {
      done();
    },
    setParam(id, unitId) {
      var that = this;
      that.searchParam.orderId = id;
      that.searchParam.ctUnitId = unitId;
      that.refresh();
    },
    beforeRefresh(searchParam) {
      //查询之前的方法
      if (!this.startAndEndTime) {
        this.searchParam.startTime = "";
        this.searchParam.endTime = "";
      } else {
        if (this.startAndEndTime.length > 0) {
          this.searchParam.startTime = this.startAndEndTime[0];
          this.searchParam.endTime = this.startAndEndTime[1];
        }
      }
      if (this.searchParam.startTime) {
        searchParam.startTime = this.searchParam.startTime;
      }
      if (this.searchParam.endTime) {
        searchParam.endTime = this.searchParam.endTime;
      }
      if (this.searchParam.orderId) {
        searchParam.orderId = this.searchParam.orderId;
      }
      if (this.searchParam.ctUnitId) {
        searchParam.ctUnitId = this.searchParam.ctUnitId;
      }
      return searchParam;
    },
    refresh() {
      //查询
      let that = this;
      var searchParam = {};
      var param = {
        param: JSON.stringify(this.beforeRefresh(searchParam))
      };
      that.$util._formPost(
        false,
        that,
        that.ref,
        param,
        api.url_synergism_payments_list,
        function(_r) {
          that.tableData = _r.data;
        }
      );
    }
  }
};
</script>

<style scoped lang='scss'>
.window {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 2001;
}

#manage {
  @include routerView;
  width: 96%;
  margin: 0 auto;
}

.colse {
  width: 100%;
  height: 38px;
  position: relative;
}

.colse > p {
  color: #000;
  font-size: 30px;
  transform: rotate(45deg);
  position: absolute;
  top: -4px;
  right: 9px;
  cursor: pointer;
}

.firstInput {
  @include inputLocation(440px);
}



.firstInput > p {
  color: #000;
}

.table {
  @include table;
}

.page {
  @include page;
}

.condition {
  @include condition;
}

.formInput {
  @include formInput;
}
.formBtn {
  @include formBtn;
}
.line {
  @include line;
}
</style>
<style lang='scss'>
.dialogForm {
  @include dialogForm;
}
</style>


// WEBPACK FOOTER //
// src/views/mod_synergism_manage/paymentFlow.vue